import { RouteName, TextKey } from '@mews-commander/enums';
import { WithBillId } from '@mews-commander/types';
import { TextWithLinks } from '@mews-commander/ui';
import { useLocalizeText } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { Typography } from '@optimus-web/core';

export const ActionLogInfo = ({ billId }: WithBillId) => {
    const localizeText = useLocalizeText();
    const resolveRoute = useResolveRoute();

    const billActionLogUrl = resolveRoute(RouteName.BillActionLog, { id: billId });

    return (
        <Typography textStyle="bodySmall" as="div">
            <TextWithLinks
                links={[
                    {
                        id: 'actionLog',
                        url: billActionLogUrl,
                        text: localizeText({ textKey: TextKey.ActionLog }),
                    },
                ]}
                text={localizeText({
                    textKey: TextKey.BillReinstateActionInfo,
                })}
            />
        </Typography>
    );
};
